import { computed, toValue } from "vue";
import { useBuiltCampaign } from "./useBuiltCampaign";
import { getCampaignFrontendAssets } from "../model/frontend-asset/getCampaignFrontendAssets";
export const useCampaignFrontendAssets = (campaignId) => {
    const { builtCampaign, primer } = useBuiltCampaign(campaignId);
    const campaignFrontendAssets = computed(() => {
        const builtCampaignValue = toValue(builtCampaign);
        if (!builtCampaignValue) {
            return [];
        }
        return getCampaignFrontendAssets(builtCampaignValue);
    });
    return {
        campaignFrontendAssets,
        primer,
    };
};
